// extracted by mini-css-extract-plugin
export var gif = "_ll-0";